import { SortingState } from '@tanstack/react-table';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

const useQueryUrlSorting = (defaultSorting?: SortingState) => {
  const location = useLocation();

  const sortingDefault: SortingState | undefined = useMemo(() => {
    const q = new URLSearchParams(location.search);
    const sortingId = q.get(`sorting_id`);
    const sortingDesc = q.get(`sorting_desc`);

    if (sortingId && sortingDesc) {
      return [
        {
          id: sortingId,
          desc: sortingDesc.toLowerCase() === 'true',
        },
      ];
    }

    if (defaultSorting) {
      return defaultSorting;
    }

    return undefined;
  }, [location.search, defaultSorting]);

  return sortingDefault;
};

export default useQueryUrlSorting;
